import { Box } from '@mui/material';

interface TabPanelProps {
    children: React.ReactNode;
    value: number;
    index: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => {
    return (
        <Box role="tabpanel" hidden={value !== index} id={`tabpanel-${index}`} aria-labelledby={`tab-${index}`} sx={{ p: 2 }}>
            {value === index && children}
        </Box>
    );
};

export default TabPanel;
